module.exports = __webpack_public_path__ + "img/time.45ce9fd3.svg";